// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3YdDC","savePackageButton":"ClientWallet_savePackageButton__28AC8"};